import styled from 'styled-components';

import { breakpoints } from '@soluto-private/mx-asurion-ui-react';

export const Layout = styled.div`
  --headerHeight: 64px;
  --footerHeight: 80px;

  --pageLayoutPadding: 16px;
  --pageLayoutTopOffset: var(--headerHeight);

  ${breakpoints.md} {
    --pageLayoutPadding: 24px;
  }

  ${breakpoints.lg} {
    --pageLayoutPadding: 48px;
  }
`;
